import { render, staticRenderFns } from "./Compare.vue?vue&type=template&id=4e74a095&scoped=true&"
import script from "./Compare.vue?vue&type=script&lang=js&"
export * from "./Compare.vue?vue&type=script&lang=js&"
import style0 from "./Compare.vue?vue&type=style&index=0&id=4e74a095&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e74a095",
  null
  
)

export default component.exports